// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const feraligatr: PokeData = {
  "id": 160,
  "name": "feraligatr",
  "height": 23,
  "weight": 888,
  "base_experience": 239,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "thrash",
    "leer",
    "bite",
    "water-gun",
    "hydro-pump",
    "low-kick",
    "agility",
    "rage",
    "screech",
    "slash",
    "flail",
    "scary-face",
    "mud-slap",
    "crunch",
    "superpower",
    "aqua-tail",
    "ice-fang",
    "chip-away"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "hydro-pump",
    "scary-face",
    "mud-slap",
    "crunch",
    "superpower",
    "aqua-tail",
    "ice-fang",
    "water-spout",
    "bubble",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 81,
    "item": null,
    "species": [
      {
        "name": "totodile",
        "order": 190,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "croconaw",
        "order": 191,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 158,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "feraligatr",
        "order": 192,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 159,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 115,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
